(function() {
  // ── Global guards ──────────────────────────────────────────────
  if (window.__lbInit) return;
  window.__lbInit = true;

var isMobile = ('ontouchstart' in window) && screen.width <= 768;

  // ── Lightbox DOM ───────────────────────────────────────────────
  var imgs = [], idx = 0, busy = false;
  var scale = 1, ls = 1;
  var tx = 0, ty = 0, stx = 0, sty = 0;
  var sd = 0, smx = 0, smy = 0;
  var tsx = 0, tsy = 0, lastTap = 0, mode = '';

  var ov = document.createElement('div');
  ov.id = 'custom-lb';
  ov.style.cssText = 'display:none;position:fixed;top:0;left:0;width:100%;height:100%;background:#000;z-index:2147483647;overflow:hidden;touch-action:none;';

  var im = document.createElement('img');
  im.style.cssText = 'position:absolute;top:50%;left:50%;max-width:100%;max-height:100%;object-fit:contain;transform:translate(-50%,-50%);transform-origin:center center;pointer-events:none;-webkit-user-drag:none;will-change:transform;';

  var cb = document.createElement('div');
  cb.innerHTML = '&#10005;';
  cb.style.cssText = 'position:absolute;top:16px;right:16px;width:44px;height:44px;background:rgba(255,255,255,0.25);border:2px solid rgba(255,255,255,0.8);border-radius:50%;color:#fff;font-size:20px;display:flex;align-items:center;justify-content:center;z-index:10;cursor:pointer;';

  var ct = document.createElement('div');
  ct.style.cssText = 'position:absolute;bottom:20px;left:50%;transform:translateX(-50%);color:#fff;font-size:13px;background:rgba(0,0,0,0.5);padding:4px 14px;border-radius:20px;pointer-events:none;white-space:nowrap;';

  ov.appendChild(im); ov.appendChild(cb); ov.appendChild(ct);
  document.body.appendChild(ov);

  // ── Transform helpers ──────────────────────────────────────────
  function applyT(an) {
    im.style.transition = an ? 'transform 0.22s ease' : 'none';
    im.style.transform = 'translate(calc(-50% + ' + tx + 'px), calc(-50% + ' + ty + 'px)) scale(' + scale + ')';
  }

  function resetT(an) {
    scale = 1; ls = 1; tx = 0; ty = 0; stx = 0; sty = 0;
    im.style.transition = an ? 'transform 0.22s ease' : 'none';
    im.style.transform = 'translate(-50%,-50%) scale(1)';
  }

  function clamp() {
    if (scale <= 1) { tx = 0; ty = 0; return; }
    var mw = Math.max(0, (im.offsetWidth * scale - window.innerWidth) / 2);
    var mh = Math.max(0, (im.offsetHeight * scale - window.innerHeight) / 2);
    tx = Math.min(Math.max(tx, -mw), mw);
    ty = Math.min(Math.max(ty, -mh), mh);
  }

  function go(n) {
  if (busy) return;
  n = Math.max(0, Math.min(n, imgs.length - 1));
  if (n === idx) return;
  busy = true;
  var dir = n > idx ? 1 : -1;
  var W = window.innerWidth;

  // Slide current image out
  im.style.transition = 'transform 0.25s ease-out';
  im.style.transform = 'translate(calc(-50% + ' + (-dir * W) + 'px), -50%) scale(1)';

  setTimeout(function() {
    // Swap image and reset position instantly (no transition)
    idx = n;
    im.src = imgs[idx];
    ct.textContent = (idx + 1) + ' / ' + imgs.length;
  
// Preload adjacent images
[idx + 1, idx - 1].forEach(function(i) {
  if (i >= 0 && i < imgs.length) {
    var pre = new Image();
    pre.src = imgs[i];
  }
});

    im.style.transition = 'none';
    im.style.transform = 'translate(calc(-50% + ' + (dir * W) + 'px), -50%) scale(1)';
    scale = 1; tx = 0; ty = 0; ls = 1; stx = 0; sty = 0;

    // Force a reflow before animating in — this prevents the jump
    void im.offsetWidth;

    im.style.transition = 'transform 0.25s ease-out';
    im.style.transform = 'translate(-50%, -50%) scale(1)';

    setTimeout(function() {
  busy = false;
  arrowLeft.style.display = idx === 0 ? 'none' : 'flex';
  arrowRight.style.display = idx === imgs.length - 1 ? 'none' : 'flex';
  if (!isMobile) arrowLeft.style.display = idx === 0 ? 'none' : 'flex';
if (!isMobile) arrowRight.style.display = idx === imgs.length - 1 ? 'none' : 'flex';
}, 260);

  }, 250);
}


  function imgKey(src) {
    try {
      var path = new URL(src).pathname;
      var file = path.split('/').pop().split('?')[0];
      file = file.replace(/(_\d+x\d*|_\d*x\d+)(\.[^.]+)$/, '$2');
      return file.toLowerCase();
    } catch(e) { return src; }
  }

  function getActiveColor() {
    var inputs = document.querySelectorAll('input[type="radio"]:checked');
    for (var i = 0; i < inputs.length; i++) {
      var n = inputs[i].name.toLowerCase();
      if (n.indexOf('color') > -1 || n.indexOf('colour') > -1) {
        return inputs[i].value.toLowerCase().trim();
      }
    }
    var selects = document.querySelectorAll('select');
    for (var s = 0; s < selects.length; s++) {
      var sn = selects[s].name.toLowerCase();
      if (sn.indexOf('color') > -1 || sn.indexOf('colour') > -1) {
        var opt = selects[s].options[selects[s].selectedIndex];
        return opt ? opt.text.toLowerCase().trim() : '';
      }
    }
    return null;
  }


  // ── Open lightbox ──────────────────────────────────────────────
function open(clickedImg) {
  var slider = document.querySelector('.product__media-list');
  if (!slider) return;

  imgs = [];
  var seen = {};

  // Build image array from visible DOM order — matches exactly what's on the page
  slider.querySelectorAll('li[data-media-id]').forEach(function(li) {
    if (li.style.display === 'none') return; // skip hidden (filtered) items
    var img = li.querySelector('img');
    if (!img) return;
    var src = img.src || img.getAttribute('data-src') || '';
    if (!src || src.indexOf('placeholder') > -1 || src.indexOf('data:image') > -1) return;
    var key = imgKey(src);
    if (seen[key]) return;
    seen[key] = true;
    try {
      var u = new URL(src);
      u.searchParams.set('width', '1080');
      u.searchParams.set('quality', '85');
      imgs.push(u.toString());
    } catch(e) { imgs.push(src); }
  });

  if (!imgs.length) return;

  // Match starting index to clicked image
  idx = 0;
  if (clickedImg) {
    var cKey = imgKey(clickedImg.src || clickedImg.getAttribute('data-src') || '');
    for (var n = 0; n < imgs.length; n++) {
      if (imgKey(imgs[n]) === cKey) { idx = n; break; }
    }
  }

  resetT(false);
  im.src = imgs[idx];
  ct.textContent = (idx + 1) + ' / ' + imgs.length;
  ov.style.display = 'block';
  if (!isMobile) arrowLeft.style.display = idx === 0 ? 'none' : 'flex';
  if (!isMobile) arrowRight.style.display = idx === imgs.length - 1 ? 'none' : 'flex';
  document.body.style.overflow = 'hidden';

  // Preload adjacent images for smooth swiping
  [idx + 1, idx - 1].forEach(function(i) {
    if (i >= 0 && i < imgs.length) {
      var pre = new Image();
      pre.src = imgs[i];
    }
  });
}

function openFromDOM(slider, color) {
  var allLis = slider.querySelectorAll('li');
  var hasColorTags = slider.querySelector('li[data-variant-color]') !== null;
  var useFilter = hasColorTags && color && color.length > 0;
  imgs = [];
  var seen = {};

  allLis.forEach(function(li) {
    var liColor = li.getAttribute('data-variant-color');
    var isSizeChart = hasColorTags && liColor === null;
    if (useFilter && !isSizeChart && liColor !== null) {
      if (liColor.toLowerCase().trim() !== color) return;
    }
    var img = li.querySelector('img');
    if (!img) return;
    var src = img.src || img.getAttribute('data-src') || '';
    if (!src || src.indexOf('placeholder') > -1 || src.indexOf('data:image') > -1) return;
    var key = imgKey(src);
    if (seen[key]) return;
    seen[key] = true;
    try {
      var u = new URL(src);
      u.searchParams.set('width', '1080');
      u.searchParams.set('quality', '85');
      imgs.push(u.toString());
    } catch(e) { imgs.push(src); }
  });

  if (!imgs.length) return;
  idx = 0;
  resetT(false);
  im.src = imgs[idx];
  ct.textContent = '1 / ' + imgs.length;
  ov.style.display = 'block';
  arrowLeft.style.display = idx === 0 ? 'none' : 'flex';
  arrowRight.style.display = idx === imgs.length - 1 ? 'none' : 'flex';
  if (!isMobile) arrowLeft.style.display = idx === 0 ? 'none' : 'flex';
  if (!isMobile) arrowRight.style.display = idx === imgs.length - 1 ? 'none' : 'flex';
  document.body.style.overflow = 'hidden';
}

window.__lbOpen = open;



function preloadAndOpen(clickedImg) {
  var slider = document.querySelector('.product__media-list');
  if (!slider) { open(clickedImg); return; }

  var lazyImgs = slider.querySelectorAll('img');
  var toLoad = [];

  lazyImgs.forEach(function(img) {
    var needsLoad = !img.complete || img.naturalWidth === 0;
    if (img.getAttribute('data-src') && (!img.src || img.src.indexOf('data:image') > -1)) {
      img.src = img.getAttribute('data-src');
      needsLoad = true;
    }
    img.removeAttribute('loading');
    if (needsLoad && img.src && img.src.indexOf('data:image') === -1) {
      toLoad.push(img);
    }
  });

  if (!toLoad.length) { open(clickedImg); return; }

  var done = 0;
  var total = toLoad.length;
  var opened = false;

  function tryOpen() {
    if (opened) return;
    opened = true;
    open(clickedImg);
  }

  var timeout = setTimeout(tryOpen, 1500);

  toLoad.forEach(function(img) {
    if (img.complete && img.naturalWidth > 0) {
      done++;
      if (done >= total) { clearTimeout(timeout); tryOpen(); }
    } else {
      img.addEventListener('load', function() {
        done++;
        if (done >= total) { clearTimeout(timeout); tryOpen(); }
      }, { once: true });
      img.addEventListener('error', function() {
        done++;
        if (done >= total) { clearTimeout(timeout); tryOpen(); }
      }, { once: true });
    }
  });
}


  // ── Close ──────────────────────────────────────────────────────
  function close() {
    ov.style.display = 'none';
    document.body.style.overflow = '';
    resetT(false);
  }

  cb.addEventListener('touchend', function(e) { e.preventDefault(); e.stopPropagation(); close(); }, { passive: false });
  cb.addEventListener('click', function(e) { e.stopPropagation(); close(); });

    // ── Desktop: mouse wheel zoom ──────────────────────────────────
  ov.addEventListener('wheel', function(e) {
    e.preventDefault();
    var delta = e.deltaY > 0 ? -0.2 : 0.2;
    scale = Math.min(Math.max(scale + delta, 1), 5);
    if (scale === 1) { tx = 0; ty = 0; }
    clamp();
    applyT(false);
  }, { passive: false });

  // ── Desktop: arrow key + click navigation ─────────────────────
  document.addEventListener('keydown', function(e) {
    if (ov.style.display === 'none') return;
    if (e.key === 'ArrowRight') go(idx + 1);
    if (e.key === 'ArrowLeft') go(idx - 1);
    if (e.key === 'Escape') close();
  });

  // ── Desktop: arrow buttons ─────────────────────────────────────
  var arrowLeft = document.createElement('button');
  arrowLeft.id = 'lb-arrow-left';
  arrowLeft.innerHTML = '&#8249;';
  arrowLeft.style.cssText = 'position:absolute;left:10px;top:50%;transform:translateY(-50%);width:44px;height:44px;background:rgba(255,255,255,0.25);border:2px solid rgba(255,255,255,0.8);border-radius:50%;color:#fff;font-size:28px;display:flex;align-items:center;justify-content:center;z-index:10;cursor:pointer;padding:0;padding-right:2px;';
  if (isMobile) arrowLeft.style.display = 'none';




  var arrowRight = document.createElement('button');
  arrowRight.id = 'lb-arrow-right';
  arrowRight.innerHTML = '&#8250;';
  arrowRight.style.cssText = 'position:absolute;right:10px;top:50%;transform:translateY(-50%);width:44px;height:44px;background:rgba(255,255,255,0.25);border:2px solid rgba(255,255,255,0.8);border-radius:50%;color:#fff;font-size:28px;display:flex;align-items:center;justify-content:center;z-index:10;cursor:pointer;padding:0;padding-left:2px;';
  if (isMobile) arrowRight.style.display = 'none';

  arrowLeft.addEventListener('click', function(e) { e.stopPropagation(); go(idx - 1); });
  arrowRight.addEventListener('click', function(e) { e.stopPropagation(); go(idx + 1); });

  ov.appendChild(arrowLeft);
  ov.appendChild(arrowRight);


  // ── Touch handlers ─────────────────────────────────────────────
  ov.addEventListener('touchstart', function(e) {
  if (ov.style.display === 'none') return; // don't intercept when closed
  e.preventDefault();

    if (e.touches.length === 2) {
      mode = 'pinch';
      sd = Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY);
      smx = (e.touches[0].clientX + e.touches[1].clientX) / 2;
      smy = (e.touches[0].clientY + e.touches[1].clientY) / 2;
      ls = scale; stx = tx; sty = ty;
      im.style.transition = 'none';
    } else if (e.touches.length === 1) {
      tsx = e.touches[0].clientX;
      tsy = e.touches[0].clientY;
      stx = tx; sty = ty;
      mode = '';
      var now = Date.now();
      if (now - lastTap < 280) {
        if (scale > 1) resetT(true);
        else { scale = 2.5; ls = 2.5; applyT(true); }
      }
      lastTap = now;
    }
  }, { passive: false });

 ov.addEventListener('touchmove', function(e) {
  if (ov.style.display === 'none') return;
  e.preventDefault();

    if (e.touches.length === 2 && mode === 'pinch') {
      var nd = Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY);
      var ns = Math.min(Math.max(ls * nd / sd, 1), 5);
      var nmx = (e.touches[0].clientX + e.touches[1].clientX) / 2;
      var nmy = (e.touches[0].clientY + e.touches[1].clientY) / 2;
      tx = stx * (ns / ls) + (nmx - smx * (ns / ls));
      ty = sty * (ns / ls) + (nmy - smy * (ns / ls));
      scale = ns;
      clamp();
      applyT(false);
    } else if (e.touches.length === 1) {
      var dx = e.touches[0].clientX - tsx;
      var dy = e.touches[0].clientY - tsy;
      if (!mode && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) {
        mode = scale > 1 ? 'pan' : 'swipe';
      }
      if (mode === 'pan') {
        tx = stx + dx; ty = sty + dy;
        clamp(); applyT(false);
      }
    }
  }, { passive: false });

 ov.addEventListener('touchend', function(e) {
  if (ov.style.display === 'none') return;
  e.preventDefault();
    if (mode === 'swipe') {
      var dx = e.changedTouches[0].clientX - tsx;
      var dy = e.changedTouches[0].clientY - tsy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        go(idx + (dx > 0 ? -1 : 1));
      }
    }
    if (scale < 1) resetT(true);
    ls = scale; stx = tx; sty = ty;
    mode = '';
  }, { passive: false });

    // ── Button injector ────────────────────────────────────────────
  var injecting = false;
  var observing = false;
  var observer = new MutationObserver(function(mutations) {
    if (injecting) return;
    var newLiAdded = mutations.some(function(m) {
      return Array.from(m.addedNodes).some(function(n) { return n.nodeName === 'LI'; });
    });
    if (newLiAdded) {
      observer.disconnect();
      observing = false;
      setTimeout(function() { injectButtons(); }, 100);
    }
  });

  function startObserver() {
    if (observing) return;
    var mediaList = document.querySelector('.product__media-list');
    if (mediaList) { observer.observe(mediaList, { childList: true }); observing = true; }
  }

 function injectButtons() {
  if (injecting) return;
  injecting = true;
  observer.disconnect();
  observing = false;

  document.querySelectorAll('.product__media-item').forEach(function(item) {

    var mediaArea = item.querySelector('.media') || item;

    // Bind click/touch to entire media area for all devices
    if (!mediaArea.dataset.lightboxBound) {
      mediaArea.dataset.lightboxBound = 'true';
      mediaArea.style.cursor = 'zoom-in';

    // Desktop click
    mediaArea.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    var clickedImg = mediaArea.querySelector('img');
    preloadAndOpen(clickedImg);
    }, true);

      // Mobile touch
      var touchStartX = 0, touchStartY = 0;
      mediaArea.addEventListener('touchstart', function(e) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      }, { passive: true });

     mediaArea.addEventListener('touchend', function(e) {
    var dx = Math.abs(e.changedTouches[0].clientX - touchStartX);
    var dy = Math.abs(e.changedTouches[0].clientY - touchStartY);
    if (dx < 10 && dy < 10) {
    e.preventDefault();
    e.stopImmediatePropagation();
    var clickedImg = mediaArea.querySelector('img');
    preloadAndOpen(clickedImg);
  }
}, { passive: false });
    }

  });

  setTimeout(function() {
    injecting = false;
    startObserver();
  }, 300);
}

  setTimeout(injectButtons, 100);

  document.addEventListener('variant:changed', function() {
    setTimeout(injectButtons, 400);
  });

  setTimeout(startObserver, 100);

})();

